<button (click)="onCloseClick()" class="button button--round button--outline button--icon button--close" type="button">
  <span class="material-symbols-outlined">
    close
  </span>
</button>
